import { Component } from '@angular/core';

@Component({
    selector: 'information-svg',
    templateUrl: './information.component.svg',
})
export class InformationComponent { }
